<app-test-navbar [showCompleteNavbar]="fullNavbar"></app-test-navbar>
<div>
  <div *ngIf="showTestQuestions" class="test-play-screen-div">
    <div class="scrollable">
      <app-question-number></app-question-number>
    </div>
    <div class="non-scrollable">
      <app-question-page></app-question-page>
    </div>
    <p-dialog
      [(visible)]="isTabSwitch"
      [modal]="true"
      [dismissableMask]="false"
      [closable]="true"
      [draggable]="false"
      [resizable]="false"
      [blockScroll]="true"
      appendTo="body"
    >
      <app-warning></app-warning>
    </p-dialog>
  </div>
  @if (isCameraEnforced) {
    <div class="camera-container">
      <app-camera></app-camera>
    </div>
  }
</div>

